import axiosInstance from "utils/axiosInstance";
import { WarningNetworkFailure } from "helpers/alertsweet";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export type DonateLoginPayload = {
  identifier: string;
  password: string;
};

export type DonateRegisterPayload = {
  name: string;
  email: string;
  username: string;
  phone: string;
  password: string;
  confirmPassword: string;
  referrer?: string;
};

export const publicSignIn = async ({
  identifier,
  password,
}: DonateLoginPayload): Promise<any> => {
  try {
    const url = `${BASE_URL}/donate/auth/login`;
    const res = await axiosInstance.post(url, {
      identifier,
      password,
    });
    console.log("login res.data:", res.data);
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }

    console.error("error", error);
    throw error;
  }
};

export const publicRegister = async ({
  name,
  email,
  username,
  phone,
  password,
  confirmPassword,
  referrer,
}: DonateRegisterPayload): Promise<any> => {
  try {
    const url = `${BASE_URL}/donate/auth/register`;
    const res = await axiosInstance.post(url, {
      name,
      email,
      username,
      phone,
      password,
      confirmPassword,
      ...(referrer ? { referrer } : {}),
    });
    console.log("register res.data:", res.data);
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }

    console.error("error", error);
    throw error;
  }
};

export type VerifyChannel = "email" | "phone";

export const sendVerifyCode = async ({
  identifier,
  channel,
}: {
  identifier: string;
  channel: VerifyChannel;
}): Promise<any> => {
  try {
    const url = `${BASE_URL}/donate/auth/send-verify-code`;
    const res = await axiosInstance.post(url, { identifier, channel });
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }

    console.error("sendVerifyCode error", error);
    throw error;
  }
};

export const verifyCode = async ({
  identifier,
  channel,
  code,
}: {
  identifier: string;
  channel: VerifyChannel;
  code: string;
}): Promise<any> => {
  try {
    const url = `${BASE_URL}/donate/auth/verify-code`;
    const res = await axiosInstance.post(url, { identifier, channel, code });
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }

    console.error("verifyCode error", error);
    throw error;
  }
};

export type ForgotPasswordPayload = {
  identifier: string;
};

export const publicForgotPassword = async ({
  identifier,
}: ForgotPasswordPayload): Promise<any> => {
  try {
    const url = `${BASE_URL}/public/forgot-password`;
    const res = await axiosInstance.post(url, { identifier });
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }

    console.error("publicForgotPassword error", error);
    throw error;
  }
};

export type AuthForgotPasswordSendOtpPayload = {
  identifier: string;
  channel: VerifyChannel;
};

export const authForgotPasswordSendOtp = async ({
  identifier,
  channel,
}: AuthForgotPasswordSendOtpPayload): Promise<any> => {
  try {
    const url = `${BASE_URL}/donate/auth/forgot-password`;
    const res = await axiosInstance.post(url, { identifier, channel });
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }

    console.error("authForgotPasswordSendOtp error", error);
    throw error;
  }
};

export type AuthForgotPasswordVerifyPayload = {
  identifier: string;
  channel: VerifyChannel;
  code: string;
  password: string;
  confirmPassword: string;
};

export const authForgotPasswordVerify = async ({
  identifier,
  channel,
  code,
  password,
  confirmPassword,
}: AuthForgotPasswordVerifyPayload): Promise<any> => {
  try {
    const url = `${BASE_URL}/donate/auth/forgot-password/verify`;
    const res = await axiosInstance.post(url, {
      identifier,
      channel,
      code,
      password,
      confirmPassword,
    });
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }

    console.error("authForgotPasswordVerify error", error);
    throw error;
  }
};

export type PublicResetPasswordPayload = {
  identifier: string;
  password: string;
  confirmPassword: string;
  token?: string;
  code?: string;
};

export const publicResetPassword = async ({
  identifier,
  password,
  confirmPassword,
  token,
  code,
}: PublicResetPasswordPayload): Promise<any> => {
  try {
    const url = `${BASE_URL}/donate/public/reset-password`;
    const res = await axiosInstance.post(url, {
      identifier,
      password,
      confirmPassword,
      token,
      code,
    });
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }

    console.error("publicResetPassword error", error);
    throw error;
  }
};
